import React from 'react'
import * as PageTitle from 'components/PageTitle'
import { Logo } from 'components/Logo'

import * as styles from './styles.module.scss'
/**
 *
 */
const Container = ({ children }) => <div>{children}</div>

/**
 *
 */
const Header = () => {
  return (
    <div>
      <Logo />
      <div className={styles.Title}>
        <PageTitle.Title />
      </div>
    </div>
  )
}

/**
 *
 */
export const Content = () => (
  <Container>
    <Header />
  </Container>
)
